import type SelectedEleManager from '@src/slide/application/service/selection/selected-ele-manager';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { isGroupModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { Nullable } from '@src/slide/infrastructure/module/independent/types';

export class TabActionService {
    // tab切换，选择的model随之切换
    public tabSelectedModelChange(curSlide: ISlideModel, selectedElements: SelectedEleManager) {
        const { selectedArray } = selectedElements;
        const selectedElementsLength = selectedElements.length;
        if (selectedElementsLength === 0) {
            this.setElementSelected(selectedElements, curSlide.children[0]);
        } else {
            const selectedArrayLength = selectedArray?.length;
            const lastSelectedElement = selectedArray?.[(selectedArrayLength ?? 1) - 1];
            this.setElementSelected(selectedElements, this.findNextSelectModel(curSlide, lastSelectedElement));
        }
    }

    // 设置元素为选择态
    private setElementSelected(selectedElements: SelectedEleManager, component: Nullable<IElementBaseModel>) {
        if (!component) return;
        selectedElements.clear();
        selectedElements.add(component);
        // 添加Root Group 逻辑
        const selectedArr = selectedElements.selectedArrayForType(SelectedEleMgrType.SLIDE);
        const rootGroup = component.rootGroupModel;
        if (rootGroup && selectedArr.indexOf(rootGroup) === -1) {
            selectedElements.add(rootGroup);
        }
    }

    // 在slide中查找下一个可选元素
    private findNextSelectModel(curSlide: ISlideModel, lastSelectedElement: Nullable<IElementBaseModel>) {
        const { children } = curSlide;
        const { length } = children;
        let nextModel: Nullable<IElementBaseModel> = null;
        let index = 0;
        for (index; index < length; index++) {
            const element = children[index];
            const isSelected = element.key === lastSelectedElement?.key;
            if (isGroupModel(element)) {
                nextModel = this.findNextModelInGroup(isSelected, children, index, lastSelectedElement?.key);
            } else if (isSelected) {
                nextModel = this.getSelectModel(children, index);
            }
            if (nextModel) break;
        }
        if (index >= length) {
            [nextModel] = children;
        }
        return nextModel;
    }

    // 在group中查找下一个可选元素
    private findNextModelInGroup(
        isSelected: boolean,
        children: IElementBaseModel[],
        index: number,
        lastSelectedElementKey: Nullable<string>,
    ) {
        let nextModel: Nullable<IElementBaseModel> = null;
        let element: Nullable<IElementBaseModel> = children[index];
        if (isSelected) {
            do {
                element = element.children[0] as IElementBaseModel;
            } while (isGroupModel(element));
            nextModel = element;
        } else {
            const { hasSelected, nextSelectModel } = this
                .findNextModelInChildGroup(element as IGroupModel, lastSelectedElementKey);
            if (nextSelectModel) {
                nextModel = nextSelectModel;
            } else if (hasSelected) {
                nextModel = this.getSelectModel(children, index);
            }
        }
        return nextModel;
    }

    // 在group的child group中查找下一个可选元素，返回selectModel
    private findNextModelInChildGroup(groupModel: IGroupModel, lastSelectedElementKey: Nullable<string>) {
        const { children } = groupModel;
        const { length } = children;
        let selectModel: { hasSelected: boolean, nextSelectModel: Nullable<IElementBaseModel> } = {
            hasSelected: false,
            nextSelectModel: null,
        };
        for (let index = 0; index < length; index++) {
            const element = children[index];
            if (isGroupModel(element)) {
                selectModel = this.findNextModelInChildGroup(element, lastSelectedElementKey);
                if (selectModel.hasSelected && !selectModel.nextSelectModel) {
                    selectModel.nextSelectModel = this.getSelectModel(children, index);
                }
            } else {
                if (element.key === lastSelectedElementKey) {
                    selectModel.hasSelected = true;
                    selectModel.nextSelectModel = this.getSelectModel(children, index);
                }
            }
            if (selectModel.hasSelected) break;
        }
        return selectModel;
    }

    //  若所选model在group中，返回selectModelList
    private getSelectModel(children: IElementBaseModel[], index: number) {
        let nextSelectModel: Nullable<IElementBaseModel> = null;
        const nextIndex = index + 1;
        if (nextIndex < children.length) {
            nextSelectModel = children[nextIndex];
        }
        return nextSelectModel;
    }
}
